/**
 * ProtectedRoute.jsx - Protected route component that requires authentication
 */
import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, resetAndLogin } = useAuth();

  if (isLoading) {
    return <div className="flex justify-center items-center h-screen">Loading...</div>;
  }

  // Show a message and manual login option if not authenticated
  if (!isAuthenticated) {
    // Get timestamp to see if we've been waiting too long (5+ seconds)
    const authAttemptTimestamp = sessionStorage.getItem('msal_auth_attempt');
    const currentTime = Date.now();
    const showManualOption = authAttemptTimestamp &&
      (currentTime - parseInt(authAttemptTimestamp) > 5000);

    return (
      <div className="flex flex-col justify-center items-center h-screen">
        <div className="text-lg mb-4">Authenticating...</div>

        {/* Show manual option after waiting a while */}
        {showManualOption && (
          <div className="text-center">
            <div className="mb-2 text-sm text-gray-600">
              If you're not automatically redirected:
            </div>
            <button
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              onClick={resetAndLogin}
            >
              Retry Authentication
            </button>
          </div>
        )}
      </div>
    );
  }

  return children ? children : <Outlet />;
};

export default ProtectedRoute;